module.exports = __webpack_public_path__ + "static/media/mail_n_pedido.f90e14cd.png";